import { ConsentsLedger, LegalConsent, OnConsentChange } from '../LegalConsents.types';

export type LinkBehavior = 'accordion' | 'default';
export type AnchorBehavior = 'newTab' | 'default';

export interface ConsentsListProps {
  consentState: ConsentsState;
  validateErrors: boolean;
  onConsentChange: OnConsentChange;
  anchorBehavior: AnchorBehavior;
  linkBehavior: LinkBehavior;
  closeAccordionBtnLabel: string | null;
  openAccordionBtnLabel: string | null | null;
}

export enum ConsentErrorType {
  NONE = 'none',
  NO_ENTRIES_FOUND = 'noEntriesFound',
  INTERNAL_VALIDATION_ERROR = 'internalValidationError',
  ALL_REQUIRED_CONSENTS_NOT_SELECTED = 'allRequiredConsentsNotSelected',
}

export interface ConsentError {
  type: ConsentErrorType;
  message: string | null;
}

export type ConsentsSectionTypes = Record<string, unknown>;

export interface ConsentsState {
  list: LegalConsent[];
  sectionTypes: ConsentsSectionTypes;
  consentsLedger: ConsentsLedger;
  error: ConsentError;
}

export type ConsentsCheckListModalInfo = {
  showModal: boolean;
  href: string;
};
